import { useCallback, useEffect, useState } from 'react'
import axios from 'axios'
import { PageTitle } from '../../../_metronic/layout/core'

const todayLogUrl = `${process.env.REACT_APP_THEME_API_URL}/logs/today`

const CurrentLog = () => {
    const [html, setHtml] = useState('')
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(true)

    const loadLog = useCallback(() => {
        setLoading(true)
        setError('')
        axios
            .get(todayLogUrl, { responseType: 'text' })
            .then((response) => {
                setHtml(typeof response.data === 'string' ? response.data : '')
            })
            .catch((err) => {
                setHtml('')
                if (err?.response?.status === 401) {
                    setError('Sign in to view the current log.')
                    return
                }
                setError('Unable to load the current log.')
            })
            .finally(() => setLoading(false))
    }, [])

    useEffect(() => {
        loadLog()
    }, [loadLog])

    return (
        <>

            <div className='card'>
                <div className='card-header border-0 pt-6'>
                    <div className='card-title'>
                        <h3 className='fw-bold m-0'>Current Log</h3>
                    </div>
                    <div className='card-toolbar'>
                        <button type='button' className='btn btn-light-primary' onClick={loadLog} disabled={loading}>
                            Refresh
                        </button>
                    </div>
                </div>
                <div className='card-body pt-0'>
                    {loading && (
                        <div className='d-flex justify-content-center py-15'>
                            <div className='spinner-border text-primary' role='status'>
                                <span className='visually-hidden'>Loading</span>
                            </div>
                        </div>
                    )}
                    {!loading && error && <div className='alert alert-danger'>{error}</div>}
                    {!loading && html && (
                        <iframe
                            title='Current Log'
                            sandbox=''
                            srcDoc={html}
                            style={{
                                width: '100%',
                                height: 'calc(100vh - 260px)',
                                minHeight: 480,
                                border: '1px solid #3c3c3c',
                                borderRadius: 8,
                                background: '#1e1e1e',
                            }}
                        />
                    )}
                </div>
            </div>
        </>
    )
}

export default CurrentLog
